import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTickersAction } from "../actions";
import { instrumentSelector, selectedInstrumentSelector, setSelectedInstrument } from "../store/slice/trade";

/**
 *
 * @returns {[{
 *  instruments: (import("../..").IInstrument)[],
 *  loading: boolean,
 *  error: object,
 * }, {
 *  getInstruments: () => void
 * }]}
 */
const useInstruments = () => {
  const instrumentsState = useSelector(instrumentSelector);
  const dispatch = useDispatch();

  const getInstruments = useCallback(instrumentIds => dispatch(getTickersAction(instrumentIds)), [dispatch]);

  return [instrumentsState, { getInstruments }];
};

/**
 *
 * @returns {[{
 *  selectedInstrument: (import("../..").IInstrument),
 * }, {
 * onChangeSelectedInstrument: (id: (import("../..").IInstrument['instrumentId'])) => void
 * }]}}
 */
export const useInstrument = () => {
  const selectedInstrument = useSelector(selectedInstrumentSelector);
  const dispatch = useDispatch();
  const onChangeSelectedInstrument = useCallback(
    id => {
      dispatch(setSelectedInstrument(id));
    },
    [dispatch]
  );
  return [{ selectedInstrument }, { onChangeSelectedInstrument }];
};

export default useInstruments;
